<template>
  <div>
    <NuxtLoadingIndicator
      color="#ed1c24"
      :height="5"
    />
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>

<script lang="ts" setup>
import { defineOrganization, defineAddress } from 'nuxt-schema-org/schema';

const route = useRoute();

useHead({
  bodyAttrs: {
    class: () => `layout-${route.meta.layout || 'default'}`,
  },
});

useSchemaOrg([
  defineOrganization({
    '@type': ['Organization', 'Store', 'OnlineStore'],
    'name': 'KYGUNCO',
    'alternateName': 'Kentucky Gun Company',
    'logo': '/logos/kygunco.svg',
    'brand': { '@type': 'Brand', 'name': 'KYGUNCO', 'logo': '/logos/kygunco.svg' },
    'telephone': '+1-502-348-3594',
    'priceRange': '$$',
    'email': 'info@kygunco.com',
    'hasMap': 'https://www.google.com/maps/dir/?q=place_id:ChIJfwecWCBSaIgRguIjuoPha40',
    'geo': {
      '@type': 'GeoCoordinates',
      'latitude': 37.8032518,
      'longitude': -85.4252895,
    },
    'knowsAbout': [
      'Firearms sales and transfers',
      'FFL dealers and compliance',
      'Optics and accessories',
      'Outdoor and hunting equipment',
    ],
    'contactPoint': [
      {
        '@type': 'ContactPoint',
        'contactType': 'Customer Service',
        'telephone': '+1-502-348-3594',
        'email': 'info@kygunco.com',
        'availableLanguage': ['English'],
        'hoursAvailable': {
          '@type': 'OpeningHoursSpecification',
          'dayOfWeek': ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
          'opens': '09:00',
          'closes': '17:00',
        },
      },
    ],
    'openingHoursSpecification': {
      dayOfWeek: [
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
      ],
      opens: '09:00',
      closes: '18:00',
    },
    'foundingDate': '1946-01-01',
    'address': defineAddress({
      streetAddress: '401 Glenwood Drive',
      addressLocality: 'Bardstown',
      addressRegion: 'KY',
      postalCode: '40004',
      addressCountry: 'US',
    }),
    'hasMerchantReturnPolicy': {
      '@type': 'MerchantReturnPolicy',
      'name': 'Standard Return Policy',
      'inStoreReturnsOffered': true,
      'merchantReturnDays': '30',
      'returnPolicyCategory': 'MerchantReturnFiniteReturnWindow',
      'returnMethod': ['ReturnByMail', 'ReturnInStore'],
      'returnFees': 'FreeReturn',
      'returnPolicyCountry': {
        '@type': 'Country',
        'name': ['US'],
      },
      'refundType': ['ExchangeRefund', 'FullRefund', 'StoreCreditRefund'],
      'applicableCountry': 'US',
    },
    'shippingDetails': {
      '@type': 'OfferShippingDetails',
      'shippingRate': {
        '@type': 'MonetaryAmount',
        'value': '0',
        'currency': 'USD',
      },
      'shippingDestination': {
        '@type': 'DefinedRegion',
        'addressCountry': ['US'],
      },
      'deliveryTime': {
        '@type': 'ShippingDeliveryTime',
        'handlingTime': {
          '@type': 'QuantitativeValue',
          'minValue': 2,
          'maxValue': 10,
          'unitCode': 'DAY',
        },
        'transitTime': {
          '@type': 'QuantitativeValue',
          'minValue': 2,
          'maxValue': 7,
          'unitCode': 'DAY',
        },
      },
    },
    'paymentAccepted': [
      'Credit Card',
      'Credova',
      'Sezzle',
    ],
    'currenciesAccepted': ['USD'],
    'hasOfferCatalog': {
      '@type': 'OfferCatalog',
      'name': 'KYGUNCO Catalog',
      'url': '/search',
    },
    'sameAs': [
      'https://x.com/kygunco',
      'https://www.facebook.com/kentuckygunco',
      'https://www.instagram.com/kygunco',
      'https://www.youtube.com/@thekentuckygunco',
      'https://rumble.com/c/KYGUNCO',
    ],
  }),
]);
</script>
